import axios from 'axios';

const axiosGptNamerInstance = axios.create({
    baseURL: process.env.REACT_APP_API_GPT_NAMER,
    auth: {
        username: 'admin',
        password: 'L-BYORJYbEwq00',
    },
    withCredentials: true,
})

export default axiosGptNamerInstance
